<template>
  <AppMainDrawer>
    <template #drawer>
      <DrawerStyled v-if="pageHasFilters[$route.name]">
        <template #drawer-content>
          <ExpandableFilters />
        </template>
      </DrawerStyled>
    </template>
    <template #content>
      <div class="page-content">
        <LibrariesTopBar
          v-model="filterDrawerStore.open"
          :totals="{ total_page_requisitions: total }"
        >
          <template #post-tooltip>
            <RequisitionLeverMessage v-if="showLeverMessage" />
          </template>
        </LibrariesTopBar>
        <div>
          <router-view
            v-slot="{ Component }"
            @track-page-load="$emit('track-page-load', $event)"
          >
            <component :is="Component" />
          </router-view>
        </div>
      </div>
    </template>
  </AppMainDrawer>
</template>

<script>
import AppMainDrawer from '@/components/shared/AppMainDrawer.vue';
import DrawerStyled from '@/components/shared/DrawerStyled.vue';
import LibrariesTopBar from '@/components/library/LibrariesTopBar.vue';
import ExpandableFilters from '@/components/filter/ExpandableFilters.vue';
import { mapState, mapStores, mapActions } from 'pinia';
import { useLibrary } from '@/stores/library/library';
import { useAppBase } from '@/stores/app/base';
import { useRequisitionLibrary } from '@/stores/requisitions/requisitionLibrary';
import { useFilters } from '@/stores/filters/filters';
import { useSubMenu } from '@/stores/filters/subMenu';
import { TYPE_LEVER } from '@/helpers/constants/integrationTypes';
import { useAppAuthData } from '@/stores/app/authData';
import { useFilterDrawer } from '@/stores/filters/filterDrawer';
import { useTooltips } from '@/stores/insights/tooltips';
import { filtersTooltipKeys } from '@/helpers/constants/filtersTooltipKeys';
import RequisitionLeverMessage from '@/components/requisitions/RequisitionLeverMessage.vue';

export default {
  name: 'RequisitionLibrary',
  components: {
    AppMainDrawer,
    DrawerStyled,
    ExpandableFilters,
    LibrariesTopBar,
    RequisitionLeverMessage,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapStores(useFilterDrawer),
    ...mapState(useRequisitionLibrary, ['total']),
    ...mapState(useAppAuthData, ['authData']),
    ...mapState(useAppBase, ['pageHasFilters']),
    showLeverMessage() {
      return this.integrationTypeKey === TYPE_LEVER;
    },
    integrationTypeKey() {
      return this.authData.integrationTypeKey;
    },
  },
  async mounted() {
    await this.init({ router: this.$router });
    await this.loadTooltips(filtersTooltipKeys);
  },
  beforeUnmount() {
    this.clearPersistentFilters();

    this.setSelectedSubMenuOption(null);
  },
  methods: {
    ...mapActions(useLibrary, ['init']),
    ...mapActions(useFilters, ['clearPersistentFilters']),
    ...mapActions(useSubMenu, ['setSelectedSubMenuOption']),
    ...mapActions(useTooltips, ['loadTooltips']),
  },
};
</script>

<style lang="less" scoped>
.page-content {
  width: 100%;

  @media screen and (min-width: 1800px) {
    max-width: 1400px;
  }
}
</style>
